/*
 * @fileOverView Animations component definition.
 */

import Vue from 'vue';

/**
 * Cookie Animations
 * @type {class}
 */
Vue.component('animations-vue', {
  data: function() {
    return {
      animationsDisabled: false,
      motionQuery: null,
    }
  },

  mounted() {

    // Initialize motion query for prefers-reduced-motion media query
    this.motionQuery = window.matchMedia('(prefers-reduced-motion)');

    // Listen for changes to the prefers-reduced-motion setting
    this.motionQuery.addListener(this.handleReduceMotionChanged);

    // Check for user preferences in localStorage or reduced motion
    const animationsDisabled = localStorage.getItem('animationsDisabled');

    if (animationsDisabled === 'true') {
      this.animationsDisabled = true;
      document.documentElement.setAttribute('data-animation-pause', 'true');
    } else {
      // Check current motion setting and apply
      this.handleReduceMotionChanged();
    }
  },

  methods: {
    toggleAnimations() {
      if (this.animationsDisabled) {
        document.documentElement.setAttribute('data-animation-pause', 'true');
        localStorage.setItem('animationsDisabled', 'true');
      } else {
        document.documentElement.setAttribute('data-animation-pause', 'false');
        localStorage.removeItem('animationsDisabled');
      }
    },

    handleReduceMotionChanged() {
      // Automatically toggle animations based on user preference for reduced motion
      if (this.motionQuery.matches) {
        // If reduced motion is preferred, disable animations
        this.animationsDisabled = true;
        // Remove if the toggle animation is implemented
        localStorage.setItem('animationsDisabled', 'true');

        document.documentElement.setAttribute('data-animation-pause', 'true');
      } else if (!localStorage.getItem('animationsDisabled')) {
        // If reduced motion is not preferred, enable animations unless the user disabled it

        // Remove if the toggle animation is implemented
        localStorage.removeItem('animationsDisabled');

        this.animationsDisabled = false;
        document.documentElement.setAttribute('data-animation-pause', 'false');
      }
    },
  },
});
